import React from 'react';
import AppIcon from '@icons/app-icon';

const GroupTypeIcon = props => <AppIcon app="group" {...props} />;

export default GroupTypeIcon;
